var _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImbiancare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9.46,38.3H9.38a1,1,0,0,0-.09,2.06,1,1,0,0,0,.17-2.06Z",
    id: "path1",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09253e",
    stroke: "#09253e",
    strokeLinejoin: "round",
    d: "m 29.53,33.73 v 0 L 17.62,20.31 c 0,0 -1,0.9 -0.83,1.43 0.73,2.87 2.89,7.45 0.25,8.7 C 9.5,34 3.45,40.07 5.31,43.24 8.24,45.46 15,40.17 19.41,33.1 c 1.55,-2.47 5.84,0.21 8.6,1.28 0.52,0.2 1.52,-0.65 1.52,-0.65 z",
    id: "path2",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09253e",
    stroke: "#09253e",
    strokeMiterlimit: 5.48,
    d: "M32.5,30.68c3.55-3,6-6.41,12.53-8.19Q37.83,14.36,30.6,6.25c-2.53,6.26-6.23,8.3-9.61,11.47h0Z",
    id: "path3",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#09253e",
    stroke: "#09253e",
    strokeMiterlimit: 1.45,
    x: 23.58,
    y: 18.04,
    height: 17.95,
    transform: "translate(-11.99 22.47) rotate(-41.61)",
    id: "rect3"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#09253e",
    stroke: "#09253e",
    strokeMiterlimit: 5.48,
    points: "20.99 17.72 20.99 17.72 32.51 30.68 20.99 17.72",
    id: "polygon3",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    points: "17.62 20.31 20.99 17.72 32.51 30.68 29.53 33.73 17.62 20.31",
    id: "polygon4",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none"
    },
    id: "path4",
    cx: 9.3800001,
    cy: 39.545109,
    r: 1.2451086
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImbiancare);
export default __webpack_public_path__ + "static/media/imbiancare.aa0f752779c7e2c3d06899f7dfef5e3e.svg";
export { ForwardRef as ReactComponent };